// extracted by mini-css-extract-plugin
export default {"cards":"TemplateCards_cards__1tVUs"};